import { type Branded, brand } from '@ipfabric/utils';

export type NestedFormikName = Branded<string, 'NestedFormikName'>;
export const nestedFormikName = (s: string): NestedFormikName =>
  brand<NestedFormikName>(s);
